import { InstrumentTriangleIcon } from './InstrumentTriangleIcon';

/**
 * author: Michael Irigoyen
 * id 7A8E4735-E738-4ECE-8386-889694014C22
 * name instrument-triangle
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/instrument-triangle.svg
 * tags
 * - Music 
 */
export const DinnerBellIcon = InstrumentTriangleIcon;
export default DinnerBellIcon